export const REPORT_TYPES = {
  ISSUES: 'ISSUES',
  QUALITY_ISSUES: 'QUALITY_ISSUES',
  SINGLE_QUALITY_ISSUE: 'QUALITY_ISSUE'
};

export const ReportDefinitionId = {
  [REPORT_TYPES.QUALITY_ISSUES]: '00000000-0000-0000-0000-000000000001',
  [REPORT_TYPES.SINGLE_QUALITY_ISSUE]: '00000000-0000-0000-0000-000000000008'
};

export const listReportIds = [ReportDefinitionId[REPORT_TYPES.QUALITY_ISSUES]];

export const REPORT_COMPLETE_STATUS = 'complete';

export const REPORT_SYNC_TIMEOUT_SECONDS_DEFAULT = 60;

export const REPORT_POLLING_INTERVAL = 1000;
